import React, { useState, useRef, useEffect } from 'react';
import cx from 'classnames';

import Icon from '../../Icon';
import Input from '../../Input';
import '../styles/_phone-dropdown.scss';







export function SearchableOptionsDropdown({
  options,
  onChange = void 0,
  defaultValue
}) {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);
  const [selectedOption, setSelectedOption] = useState(defaultValue);
  const [dropdownOptions, setDropdownOptions] = useState(options);


  const toggleDropdown = () => {
    setIsVisible(!isVisible);
  };

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsVisible(false);
    }
  };

  const selectOption = (option) => {
    setSelectedOption(option);
    onChange(option);
    setIsVisible(false);
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleOptionKeyDown = (option, event) => {
    if (event.key === 'Enter') {
      selectOption(option);
    }
  };

  const renderItem = (option) =>
  <div
    role="button"
    className="dropdown-item"
    onClick={() => selectOption(option)}
    onKeyDown={(e) => handleOptionKeyDown(option, e)}
    tabIndex={0}>

      {option.prefix && <span className="dropdown-item--flag">{option.prefix}</span>}
      <span className="dropdown-item--country-name">{option.label}</span>
      {option.suffix && <span className="dropdown-item--country-code">{option.suffix}</span>}
    </div>;


  const filterOptions = (e) => {
    const { target: { value = '' } } = e || {};
    const filteredOptions = options.filter((option) => {
      const { label, suffix } = option;
      if (typeof label !== 'string') return false;
      return label.toLowerCase().includes(value.toLowerCase()) ||
      typeof suffix === 'string' && suffix.toLowerCase().includes(value.toLowerCase());
    });
    setDropdownOptions(filteredOptions);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      toggleDropdown();
    }
  };

  return (
    <div className="dropdown-container" ref={containerRef}>
      <div
        className="dropdown-trigger"
        role="button"
        onClick={toggleDropdown}
        onKeyDown={handleKeyDown}
        tabIndex={0}>

        <div className="dropdown-trigger--flag">{selectedOption.prefix}</div>
        <div>{selectedOption.suffix}</div>
        <div className="dropdown-trigger--dropdown-icon">
          <Icon name="arrowdown" size={8} />
        </div>
      </div>
      <div
        className={cx('dropdown-list', { visible: isVisible })}>

        <div className="dropdown-list__search">
          <Input
            className="dropdown-list__search--icon"
            placeholder="search"
            prefix={<Icon name="search" size={15} />}
            onChange={filterOptions} />

        </div>
        {dropdownOptions.map((option) => renderItem(option))}
        <div
          className={cx('dropdown-item',
          { 'dropdown-item--no-results': dropdownOptions.length === 0 },
          { 'dropdown-item--hide': dropdownOptions.length > 0 })}>

          No Results
        </div>
      </div>
    </div>);

}